import {FEATURE_FLAGS} from '../../../../constants';
import {hasFeatureFlag, isOpportunitiesEnabled} from '../../../shared/util/FeatureUtil';
import {EntityType} from '../Constants';

export type ListVisibility = {
	showOnOpportunityList: boolean;
	showOnProjectList: boolean;
};

export const DEFAULT_LIST_VISIBILITY: ListVisibility = {showOnOpportunityList: true, showOnProjectList: true};

// Only Project fields can appear on the Opportunity and Project lists.
export const isListVisibilityAvailable = (entityType: EntityType): boolean =>
	entityType === EntityType.PROJECT && hasFeatureFlag(FEATURE_FLAGS.CUSTOM_FIELDS_LISTS);

// Same condition the router uses for /opportunities: an account that cannot open the list has no
// use for the checkbox.
export const isOpportunityListAvailable = (): boolean => isOpportunitiesEnabled();

// A setting whose checkbox is not shown is left out, so create stores the default and edit keeps
// what is stored.
export const toListVisibilityInput = (entityType: EntityType, value: ListVisibility): Partial<ListVisibility> => {
	if (!isListVisibilityAvailable(entityType)) {
		return {};
	}
	return {
		showOnProjectList: value.showOnProjectList,
		...(isOpportunityListAvailable() ? {showOnOpportunityList: value.showOnOpportunityList} : {}),
	};
};

export const hasRemovedListVisibility = (initial: ListVisibility, current: ListVisibility): boolean =>
	(initial.showOnOpportunityList && !current.showOnOpportunityList) ||
	(initial.showOnProjectList && !current.showOnProjectList);
